"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_business(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "business-mid"), /*#__PURE__*/React.createElement("g", {
    id: "782f7578-0e24-4091-84c4-bd36842de562",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "783c0886-c76b-4c3f-a080-69a57091dc5e",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aeab5d9d-f1ca-43cf-9063-dd1744ea134d",
    "data-name": "Business_ic 2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 99.9,
    y1: 106,
    x2: 91.9,
    y2: 106,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,156l-8.6,10-8.6-10,4.19-38a4.43,4.43,0,0,1,4.41-4h0a4.43,4.43,0,0,1,4.41,4Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "cb5ccf55-6c8b-4680-a7b0-b119c2ef2fbb",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 62,
    r: 36,
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "4eca9680-4c7e-4ca9-8d27-6a91d82cdbbc",
    "data-name": "<Pfad>",
    d: "M154,166c-6.48-43.73-31.53-68-58-68s-51.51,24.27-58,68",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_business;
exports.default = _default;